<template>
  <div>
    <PublishProcess v-if="showProcess?.id" />
    <PublishPush v-if="publishInfo?.id" />
  </div>
</template>

<script lang="ts" setup>
import PublishProcess from '@/features/publish/components/process.vue'
import PublishPush from '@/features/publish/components/push.vue'

const publishInfo = usePublishInfo()
const showProcess = usePublishProcess()
</script>
